import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uae-pass',
  template: '',
  styles: []
})
export class UaePassComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.redirectToCallback();
  }

  private redirectToCallback(): void {
    // Function to get query parameters from the URL
    const getQueryParams = () => {
      const params = new URLSearchParams(window.location.search);
      return {
        code: params.get('code'),
        state: params.get('state'),
        docs: params.get('docs'),
        docsIdentifier: params.get('docsIdentifier'),
        status: params.get('status'),
        signer_process_id: params.get('signer_process_id')
      };
    };

    const getNewUrl = () => {
      const queryParams = getQueryParams();
      if(queryParams.docs && queryParams.docs.length > 0) {
        return `https://ngtest.teljoy.io/public-pages/index.html#!/accounting/uaepass/callback?docs=${queryParams.docs}&status=${queryParams.status}&signer_process_id=${queryParams.signer_process_id}`;
      }
      return `https://ngtest.teljoy.io/public-pages/index.html#!/accounting/uaepass/callback?docsIdentifier=${queryParams.docsIdentifier}&code=${queryParams.code}&state=${queryParams.state}`;
    };

    // Get the current query parameters
    const queryParams = getQueryParams();

    // Construct the new URL
    const newUrl = getNewUrl();

    // Redirect to the new URL
    window.location.href = newUrl;
  }

}
